/**
 * F's Active control (spec §3.2, §4.4, Q4): D2's "เฉพาะ campaign ที่ Active (ซ่อน N)", on by default, in the URL only.
 * "(ซ่อน N)" shows only while it is on and N > 0 (D2's R37): with it off nothing is hidden, so the words would be false.
 * data-hidden carries the raw count in both states (the live check reads it), empty until the facts are ready and
 * under either card (rules-04 H review F6, I2). It sits in F, so however empty the boxes are, turning it off
 * stays one click away (R9).
 *
 * @module components/audience/ActiveOnlyToggle
 */
import React from 'react';
import { useTranslation } from 'react-i18next';

const raw = (n: number | null): string => (n === null ? '' : String(n));

interface Props {
  on: boolean;
  /** "ซ่อน N" (R7); null until the facts are ready, and under either card. */
  hidden: number | null;
  onActive: (on: boolean) => void;
}

export const ActiveOnlyToggle: React.FC<Props> = ({ on, hidden, onActive }) => {
  const { t } = useTranslation();
  return (
    <label data-active-only data-hidden={raw(hidden)} className="inline-flex items-center gap-2 text-sm text-neutral-900">
      <input type="checkbox" checked={on} onChange={(e) => onActive(e.target.checked)} className="h-4 w-4 rounded border-neutral-400" />
      <span>{t('channels.breakdown.activeOnly')}</span>
      {on && hidden !== null && hidden > 0 && <span className="text-neutral-700">{t('channels.breakdown.hidden', { n: hidden })}</span>}
    </label>
  );
};
